import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "../HomePage.css";
import { activeManagers } from "../managersData";

const chrisBode = activeManagers.find(m => m.manager === "Dave Criss");

const navItems = [
    { label: "Home", path: "/" },
    { label: "Managers", path: "/managers" },
    { label: "Seasons", path: "/seasons" },
    { label: "League Settings", path: "/league-settings" },
];
// Matchup data for 2024 season
const matchups2024 = [
    { opponent: "Maverick", pointsFor: 123.1, pointsAgainst: 126.05 },
    { opponent: "The Decision Makers", pointsFor: 134.5, pointsAgainst: 129.1 },
    { opponent: "Ariza's Army", pointsFor: 130.6, pointsAgainst: 151.75 },
    { opponent: "RIP rashee", pointsFor: 171.85, pointsAgainst: 122.15 },
    { opponent: "Rashad's Fentmaxxers", pointsFor: 183.9, pointsAgainst: 159.95 },
    { opponent: "FAFO", pointsFor: 142.55, pointsAgainst: 165.85 },
    { opponent: "Run it Back", pointsFor: 94.6, pointsAgainst: 107.8 },
    { opponent: "Beats by Ray", pointsFor: 141.2, pointsAgainst: 118.8 },
    { opponent: "Four Loko Army", pointsFor: 159.95, pointsAgainst: 129.8 },

    { opponent: "Maverick", pointsFor: 158.7, pointsAgainst: 129.2 },
    { opponent: "The Decision Makers", pointsFor: 169.85, pointsAgainst: 155.8 },
    { opponent: "Ariza's Army", pointsFor: 184.95, pointsAgainst: 157.1 },
    { opponent: "RIP rashee", pointsFor: 167.7, pointsAgainst: 116.65 },
    { opponent: "Rashad's Fentmaxxers", pointsFor: 170.7, pointsAgainst: 142.65 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
    { opponent: "TBD", pointsFor: 0, pointsAgainst: 0 },
];

const DaveCriss = () => {
    return (
        <div className="homepage-container">
            {/* Header */}
            <header className="header">
                <nav className="nav-bar">
                    {navItems.map(({ label, path }, i) => (
                        <Link key={i} to={path} className="nav-link" tabIndex={0}>
                            {label}
                        </Link>
                    ))}
                </nav>
            </header>

            {/* Title */}
            <motion.h1
                className="footballin-title"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.1, duration: 0.6 }}
            >
                Dave Criss - Dave's Duds
            </motion.h1>

            {/* Side-by-side cards */}
            <main
                className="main-content"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2rem",
                    justifyContent: "center",
                    width: "75%",
                    margin: "2rem auto",
                }}
            >
                {/* Top two sections: About & Notable Stats */}
                <div style={{ display: "flex", gap: "2rem" }}>
                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                    >
                        <h2 className="section-title">📘 About</h2>
                        <p>
                            Manager of: <strong>Dave's Duds</strong>.<br />
                            Alternate Names: <em>N/A</em><br/>
                            First Appeared: 2024 Season<br />
                            First Championship Win: 2024 Season<br/>
                            Father of Manager <Link to="/managers/nickcriss" className="manager-name"><strong>Nick Criss</strong></Link>.<br />
                            
                        </p>
                    </motion.section>

                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.5 }}
                    >
                        <h2 className="section-title">📊 Notable Stats</h2>
                        <p>
                            <strong>Overall Record:</strong> 10-4-0<br />
                            <strong>Championship Record:</strong> 1-0<br />
                            <strong>2024–2025:</strong> 10-4-0<br />
                            <strong>2025–2026:</strong> 0-0-0
                            <br/>
                            <em>Note: Playoff games not included.</em>
                        </p>
                    </motion.section>
                </div>




                {/* New section: 2023-2024 Season header */}
                <h2 className="section-title" style={{ textAlign: "center", marginTop: "2rem" }}>
                    2024-2025 Season
                </h2>

                {/* Season two side-by-side sections */}
                <div style={{ display: "flex", gap: "2rem" }}>
                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.5 }}
                    >
                        <h2 className="section-title">📝 Draft Picks</h2>
                        {chrisBode.draftPicks[2024].length ? (
                            <ul>
                                {chrisBode.draftPicks[2024].map((pick, idx) => (
                                    <li key={idx}>
                                        Round {pick.round} - Pick {pick.pick} - {pick.player} - {pick.team}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No draft picks recorded for 2023.</p>
                        )}
                    </motion.section>

                    <motion.section
                        className="card"
                        style={{ flex: 1 }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5, duration: 0.5 }}
                    >
                        <h2 className="section-title">📈 Team & Stats</h2>

                        <div className="team-stats">
                            <p><strong>Rank:</strong> #1</p>
                            <p><strong>Season Record:</strong> 10-4-0</p>
                            <p><strong>Points for: </strong>2134.15</p>
                            <p><strong>Points against: </strong>1912.65</p>
                            <p><strong>Average PPG: </strong>152.4</p>
                            <p><strong>Average Opponent PPG: </strong>136.6</p>
                            <p><strong>Team moves: </strong>25</p>
                        </div>

                        <hr style={{ margin: '1.5rem 0' }} />

                        <div className="ending-team">
                            <h3>Ending Team</h3>
                            <p><strong>QB:</strong> Jayden Daniels, Aaron Rodgers</p>
                            <p>
                                <strong>RB:</strong> Chase Brown, Tyrone Tracy Jr, Saquon Barkley, Travis Etienne Jr, Jonathan Taylor
                            </p>
                            <p>
                                <strong>WR:</strong> Ja'Marr Chase, Drake London, Calvin Ridley, Deebo Samuel Sr, Chris Olave (IR)
                            </p>
                            <p>
                                <strong>TE:</strong> Trey McBride, Isaiah Likely
                            </p>
                            <p><strong>D/ST:</strong> Commanders, 49ers, Colts</p>
                            <p><strong>K:</strong> Cameron Dicker</p>
                        </div>
                    </motion.section>
                </div>

                {/* Matchup grid below draft picks and team & stats */}
                <motion.section
                    className="matchup-grid card"
                    style={{ marginTop: "2rem", padding: "1rem" }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.5 }}
                >
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(9, 1fr)",  // 9 columns equal width
                            gridAutoRows: "auto",
                            gap: "0.5rem",
                            width: "100%", // full width of parent container
                        }}
                    >
                        {matchups2024.map(({ opponent, pointsFor, pointsAgainst }, index) => {
                            const won = pointsFor > pointsAgainst;
                            const weekNumber = index + 1; // week number 1-18
                            return (
                                <div
                                    key={index}
                                    style={{
                                        backgroundColor: won ? "#d4edda" : "#f8d7da",
                                        border: `1px solid ${won ? "#155724" : "#721c24"}`,
                                        borderRadius: "6px",
                                        padding: "0.5rem",
                                        fontSize: "0.8rem",
                                        textAlign: "center",
                                        color: won ? "#155724" : "#721c24",
                                        userSelect: "none",
                                        minWidth: 0,
                                    }}
                                >
                                    <div>Week {weekNumber}:</div>
                                    <div>vs. {opponent}</div>
                                    <div>
                                        {pointsFor} - {pointsAgainst}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </motion.section>
            </main>

            {/* Footer */}
            <footer className="footer">Created by Nick Criss ⚡️</footer>
        </div>
    );
};

export default DaveCriss;
